import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCheck, Settings } from 'lucide-react';
import { useNotificationFeed } from '../hooks/useNotificationFeed';
import NotificationFeedList from '../components/Notifications/NotificationFeedList';
import NotificationSettings from '../components/Notifications/NotificationSettings';

const NotificationMobilePage: React.FC = () => {
  const navigate = useNavigate();
  const [view, setView] = useState<'inbox' | 'settings'>('inbox');
  const feed = useNotificationFeed();

  return (
    <div style={{ color: 'var(--text-color)' }}>
      <div
        className="flex items-center justify-between px-3 py-3 border-b sticky top-0 z-10"
        style={{ borderColor: 'var(--bg-item)', background: 'var(--bg-color)' }}
      >
        {view === 'settings' ? (
          <button onClick={() => setView('inbox')} className="flex items-center gap-1 -ml-1 p-1.5 rounded-lg active:scale-90 transition-transform">
            <ArrowLeft size={20} />
          </button>
        ) : (
          <button onClick={() => navigate(-1)} className="flex items-center gap-1 -ml-1 p-1.5 rounded-lg active:scale-90 transition-transform">
            <ArrowLeft size={20} />
          </button>
        )}
        <span className="font-bold text-base">{view === 'settings' ? 'ตั้งค่าการแจ้งเตือน' : 'แจ้งเตือน'}</span>
        <div className="flex items-center gap-1 w-[68px] justify-end">
          {view === 'inbox' && (
            <>
              <button title="อ่านทั้งหมด" onClick={feed.markAllRead} className="p-1.5 rounded-lg active:scale-90 transition-transform">
                <CheckCheck size={18} />
              </button>
              <button title="ตั้งค่า" onClick={() => setView('settings')} className="p-1.5 rounded-lg active:scale-90 transition-transform">
                <Settings size={18} />
              </button>
            </>
          )}
        </div>
      </div>

      {view === 'inbox' ? <NotificationFeedList feed={feed} variant="page" /> : <NotificationSettings />}
    </div>
  );
};

export default NotificationMobilePage;
